import m from "../../../../geodata/es2015/region/world/caribbeanHigh";
window.am4geodata_region_world_caribbeanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/caribbeanHigh.js
// module id = null
// module chunks = 